import { Fancybox } from "@fancyapps/ui";
import { fancyboxConfig } from '../react/config/fancybox';

export default class VehicleImages {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.triggers = Array.from(this.DOM.el.querySelectorAll('[data-vehicle-images-trigger]'));
        this.images = JSON.parse(this.DOM.el?.dataset?.vehicleImages || '[]');

        this.initEvents();
    }

    initEvents() {
        this.DOM.triggers.forEach((trigger) => trigger.addEventListener('click', this.openFancybox));
    }

    openFancybox = (event) => {
        const trigger = event.currentTarget;
        const index = parseInt(trigger?.dataset?.index, 10) || 0;

        Fancybox.show(
            this.images?.map((image) => ({
                src: image.image,
                thumb: image.thumbnail,
                type: 'image',
            })),
            {
                ...fancyboxConfig,
                startIndex: index,
            }
        );
    }
}

const vehicleImagesNodes = Array.from(document.querySelectorAll('[data-vehicle-images]'));
if (vehicleImagesNodes.length > 0) {
    vehicleImagesNodes.forEach((node) => { new VehicleImages(node); });
}
